export default {
  TableHeadEvoplaySessions: [
    [
      {
        displayName: 'evoplay_sessions.no',
      },
      {
        displayName: 'evoplay_sessions.username',
      },
      {
        displayName: 'evoplay_sessions.id',
      },
      {
        displayName: 'evoplay_sessions.token',
      },
    ],
  ],
};
